export default __webpack_public_path__ + "static/media/doctor-standing-with-folder-stethoscope_1291-16.2eddda45.jpg";